import delay from "../utilities/delay.js";
import togglePlaceholder from "./togglePlaceholder.js";
import createInstance from "./createInstance.js";

const focus = async (event) => {
    const element = event.target;
    togglePlaceholder(element, false);
    await delay(100);
    createInstance(element);
    element.removeEventListener('focus', focus);
};

export default focus;
